var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Comparison"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  !_vm.initialized
                    ? _c("h2", [
                        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                        _vm._v(" Loading..."),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.initialized
                    ? _c("div", [
                        _c("table", { staticClass: "table table-hover" }, [
                          _c("thead", [
                            _c(
                              "tr",
                              [
                                _c("th"),
                                _vm._v(" "),
                                _vm._l(_vm.alternatives, function (a) {
                                  return _c("th", { key: a.Id }, [
                                    _vm._v(_vm._s(a.Name)),
                                  ])
                                }),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            [
                              _vm.includeDescription === true
                                ? _c(
                                    "tr",
                                    [
                                      _c("th", [_vm._v("Description")]),
                                      _vm._v(" "),
                                      _vm._l(_vm.alternatives, function (a) {
                                        return _c("td", { key: a.Id }, [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getHtmlDescription(a)
                                              ),
                                            },
                                          }),
                                        ])
                                      }),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.includeStatus === true
                                ? _c(
                                    "tr",
                                    [
                                      _c("th", [_vm._v("Status")]),
                                      _vm._v(" "),
                                      _vm._l(_vm.alternatives, function (a) {
                                        return _c("td", { key: a.Id }, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(a.StatusName) +
                                              "\n                                    "
                                          ),
                                        ])
                                      }),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.attributes, function (attr) {
                                return _c(
                                  "tr",
                                  { key: attr.Id },
                                  [
                                    _c("th", [_vm._v(_vm._s(attr.Name))]),
                                    _vm._v(" "),
                                    _vm._l(_vm.alternatives, function (a) {
                                      return _c("td", { key: a.Id }, [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.getAttributeValue(a, attr.Id)
                                            ) +
                                            "\n                                    "
                                        ),
                                      ])
                                    }),
                                  ],
                                  2
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Close")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }